import PermissionsService from "./permissions-service";

const USER_KEY = "lamusica_cms_user_data";

const getUser = () => {
  const user = localStorage.getItem(USER_KEY)
  return user ? JSON.parse(user) : null;
};

const saveUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

const destroyUser = () => {
  localStorage.removeItem(USER_KEY);
};

const isAdmin = () => {
  const user = getUser()
  return user ? user.isAdmin : false
}

const hasPermission = (entry) => {
  if(isAdmin()) {
    return true
  }

  return PermissionsService.checkPermission(entry)
}

export default { getUser, saveUser, destroyUser, isAdmin, hasPermission };
